import { render, staticRenderFns } from "./ProjectsShare.vue?vue&type=template&id=02bfbcaa&scoped=true"
import script from "./ProjectsShare.vue?vue&type=script&lang=js"
export * from "./ProjectsShare.vue?vue&type=script&lang=js"
import style0 from "./ProjectsShare.vue?vue&type=style&index=0&id=02bfbcaa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bfbcaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02bfbcaa')) {
      api.createRecord('02bfbcaa', component.options)
    } else {
      api.reload('02bfbcaa', component.options)
    }
    module.hot.accept("./ProjectsShare.vue?vue&type=template&id=02bfbcaa&scoped=true", function () {
      api.rerender('02bfbcaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Projects/ProjectsShare.vue"
export default component.exports